import { MaybeRef, toValue, watch, ref, readonly, Ref, DeepReadonly } from "vue";

export function useShuffle<T>(input: MaybeRef<T[]>): {
  shuffled: DeepReadonly<Ref<T[]>>;
  shuffle: () => void;
} {
  const shuffled = ref<T[]>([]);

  // Fisher-Yates shuffle algorithm
  const shuffleArray = <T>(array: T[]): T[] => {
    const result = [...array];
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };

  // Метод шафлинга — шафлит текущее значение shuffled
  const shuffle = () => {
    shuffled.value = shuffleArray(shuffled.value);
  };

  // Следим за входным массивом: при изменении — сбрасываем shuffled к копии нового значения
  watch(
    () => toValue(input),
    (newVal) => {
      shuffled.value = [...newVal];
    },
    { immediate: true } // Инициализируем сразу при создании
  );

  return {
    shuffled: readonly(shuffled) as DeepReadonly<Ref<T[]>>,
    shuffle,
  };
}
